var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"rh-medform"},[_c('h1',[_vm._v("Tuteur")]),_c('form-tutoratedit',{attrs:{"ismedtut":true,"routes":_vm.routes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }